// import color from "../../../constants/color";

import color from "../../../../constants/color"


const styles = {

  TableHead: {
    color: "#878787",
    fontWeight: "400",
    whiteSpace: "nowrap", 
  },

  leaveHeading: { 
    fontWeight: "600",
    fontSize: "20px", 
  },

  tabledata: {
    borderBottom: 0,
    textTransform:"capitalize",
    whiteSpace:"nowrap"

  },
  tableAvtardata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center",
    cursor:"pointer"
  },

  tableActiondata: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-around", 
  },
  dropdown:{
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    p:0,
    height: "2.5em",

    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
    }
  },
  reason:{
    borderRadius: "8px",

    width:"100%",
    height: "4.5em",},
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  calenderInput:{
    "& .MuiInputBase-input": {
      padding: "8.5px 10px",
      width:"11.85em"
    }
  },  
  noteInput:{
    height:"4.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"14px"
    },
  },
  calender:{
    borderRadius:"5px",
  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    borderRadius:"30px",
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"8.5px 14px"
    },
    "& .MuiOutlinedInput-root":{
      padding:"0"
    }
  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text, 
    mb:1,
  },
  dateGrid: {
    display: "flex",
    alignItems: "center",
  },
  modalInputs:{
    display:"flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",

    height:"2.5em",
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root" :{
      borderRadius: "8px",

    },
  },

  deleteIcon: {
    color:"#ff0000",
    cursor:"pointer"
  },
}
export default styles
